import Swal from 'sweetalert2'

function escapeHtml(value: string): string {
  return value
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;')
}

/** HTD-themed login success modal (no broken Swal success-icon overlay). */
export function showHtdLoginSuccess(options?: {
  username?: string
  timerMs?: number
  siteName?: string
}) {
  const username = options?.username?.trim()
  const timerMs = options?.timerMs ?? 1600
  const siteName = options?.siteName?.trim() || 'HuayToday'
  const welcome = username
    ? `ยินดีต้อนรับ <strong>${escapeHtml(username)}</strong>`
    : `ยินดีต้อนรับกลับสู่ ${escapeHtml(siteName)}`

  return Swal.fire({
    title: 'เข้าสู่ระบบสำเร็จ',
    html: `
      <div class="htd-login-swal">
        <div class="htd-login-swal__icon" aria-hidden="true">
          <svg viewBox="0 0 24 24" width="30" height="30" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round">
            <path d="M20 6L9 17l-5-5" />
          </svg>
        </div>
        <p class="htd-login-swal__welcome">${welcome}</p>
        <p class="htd-login-swal__hint">กำลังพาคุณเข้าสู่ระบบ…</p>
      </div>
    `,
    showConfirmButton: false,
    allowOutsideClick: false,
    allowEscapeKey: false,
    timer: timerMs,
    timerProgressBar: true,
    customClass: {
      popup: 'htd-swal-popup htd-login-swal-popup',
      title: 'htd-swal-title htd-login-swal-title',
      htmlContainer: 'htd-swal-html htd-login-swal-html',
      timerProgressBar: 'htd-login-swal-timer',
    },
  })
}
